import PropTypes from "prop-types";
import { Box, Grid, Tooltip, Typography, Alert } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Form from "@accredo/fe-shared/components/Form/Form.jsx";
import FormSwitch from "../Form/controls/FormSwitch.jsx";
import FormDatePicker from "../Form/controls/FormDatePicker.jsx";
import SubmitButton from "@accredo/fe-shared/components/Form/controls/SubmitButton.jsx";
import DsButton from "@accredo/fe-shared/theme/components/Button.jsx";

import { Controller, useForm, useFormContext, useWatch } from "react-hook-form";

// for "due on" buttons
const QUICK_DATES = [
  { label: "in 1 Woche", days: 7 },
  { label: "in 2 Wochen", days: 14 },
  { label: "in 1 Monat", days: 30 },
  // { label: "nicht erinnern", days: null },
];

const getDateInFuture = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  date.setHours(0, 0, 0, 0);
  return date;
};

const validationSchema = yup.object({
  faellig_am: yup.mixed().required("Erinnern am ist erforderlich").nullable(),
});

const ReminderForm = ({
  defaultValues,
  onSubmit,
  onCancel,
  showIstErledigt,
  disabled,
}) => {
  return (
    <Form
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      resolver={yupResolver(validationSchema)}
      mode="onChange"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 0 }}>
        <Tooltip title={"Betreff"}>
          <Typography variant="h3">{defaultValues?.betreff}</Typography>
        </Tooltip>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <FormDatePicker
              name="faellig_am"
              label="Erinnern am"
              disabled={disabled}
              clearable={true}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <QuickDateButtons disabled={disabled} />
          </Grid>
        </Grid>

        {showIstErledigt && (
          <Alert severity="info" icon={false}>
            Erinnerung als erledigt markieren. Es wird keine Benachrichtigung
            für das ausgewählten Datum versendet.
            <Box ml={1} mt={1}>
              <FormSwitch
                name="ist_erledigt"
                label="erledigt"
                disabled={disabled}
              />
            </Box>
          </Alert>
        )}

        {/*<Box sx={{ maxWidth: "90ch" }}>*/}
        {/*  <MultilineText value={defaultValues?.beschreibung} />*/}
        {/*</Box>*/}

        <Box
          sx={{ display: "flex", gap: 2, justifyContent: "flex-end", pt: 1 }}
        >
          <DsButton variant="tertiary" onClick={onCancel}>
            Abbrechen
          </DsButton>
          {!disabled && <SubmitButton>Speichern</SubmitButton>}
        </Box>
      </Box>
    </Form>
  );
};

// ---------------------------------------------------------------------------
// Sub-component: Quick date buttons for "faellig_am"
// ---------------------------------------------------------------------------
const QuickDateButtons = ({ disabled }) => {
  const { setValue } = useFormContext();
  const faellig_am = useWatch({ name: "faellig_am" });

  if (disabled) return null;

  const handleClick = (days) => {
    if (days === null) {
      console.log("setting to ", days);
      setValue("faellig_am", null);
      return;
    }

    setValue("faellig_am", getDateInFuture(days), {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        height: "100%",
        alignItems: "center",
      }}
    >
      {QUICK_DATES.map((option) => {
        const isSelected =
          faellig_am &&
          getDateInFuture(option.days).toDateString() ===
            new Date(faellig_am).toDateString();

        return (
          <DsButton
            key={option.days}
            size="small"
            variant={isSelected ? "secondary" : "tertiary"}
            onClick={() => handleClick(option.days)}
          >
            {option.label}
          </DsButton>
        );
      })}
    </Box>
  );
};

ReminderForm.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showIstErledigt: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ReminderForm;
